import React, { useEffect, useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";

const CoordinateFinder = ({ address = "", onSetCoordinates }) => {
  const [inputAddress, setInputAddress] = useState(address);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [formatted, setFormatted] = useState("");
  const [loading, setLoading] = useState(false);

  // 부모 주소 prop이 바뀌면 내부 주소값도 갱신
  useEffect(() => {
    setInputAddress(address);
  }, [address]);

  const handleFindCoordinates = async () => {
    if (!inputAddress) return;

    setLoading(true);
    try {
      const res = await fetch(process.env.REACT_APP_WORKERS_URL+"/api/coordinates", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ address: inputAddress }),
      });

      const data = await res.json();

      if (data.lat && data.lng) {
        setLat(data.lat);
        setLng(data.lng);
        setFormatted(data.formatted);

        // 부모에게 좌표 정보 전달
        if (onSetCoordinates) {
          onSetCoordinates({
            lat: data.lat,
            lng: data.lng,
            location: `SRID=4326;POINT(${data.lng} ${data.lat})`,
          });
        }
      } else {
        alert("좌표를 찾을 수 없습니다.");
      }
    } catch (err) {
      alert("오류 발생: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 3 }}>
      <TextField
        fullWidth
        label="주소 입력"
        value={inputAddress}
        onChange={(e) => setInputAddress(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Button variant="outlined" onClick={handleFindCoordinates} disabled={loading} fullWidth>
        좌표 찾기
      </Button>

      {lat && lng && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2">📍 위도(lat): {lat}</Typography>
          <Typography variant="body2">📍 경도(lng): {lng}</Typography>
          <Typography variant="body2">🗺 주소: {formatted}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default CoordinateFinder;
